import { createBreakpoints } from "@chakra-ui/theme-tools";

export const breakpoints = createBreakpoints({
  sm: "320px",
  "2sm": "380px",
  "3sm": "560px",
  md: "768px",
  lg: "960px",
  xl: "1048px",
  baseWidth: "1440px",
  "2xl": "1600px",
  "3xl": "1920px",
});
